<template>
  <v-dialog v-model="dialogsyarat" persistent max-width="500">
    <v-card>
      <v-card-title class="primary white--text">Syarat & Ketentuan</v-card-title>
      <v-card-text>
        <SyaratKetentuanPanel/>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn text class="primary" @click="setdialogsyarat(false)">Tutup</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SyaratKetentuanPanel from '@/components/SyaratKetentuanPanel'

export default {
  name: 'DialogSyaratKetentuan',
  props: ['dialog'],
  components: {
    SyaratKetentuanPanel
  },
  data: () => ({
  }),
  mounted () {
  },
  computed: {
    ...mapState('PublicStore', ['dialogsyarat'])
  },
  methods: {
    ...mapActions('PublicStore', ['setdialogsyarat'])
  }
}
</script>

<style scoped>

</style>
